<template>
  <div>
    <div
      :id="'message-component' + message.id"
      class="pa-2 bg-white"
    >
      <div
        layout="row"
        layout-align="start start"
      >
        <v-icon
          color="#8dbfb6"
          class="mr-1"
        >mdi-{{typeIcon(message.type)}}</v-icon>
        <div
          layout="column"
          layout-align="center start"
          class="ml1-pc full-width"
        >
          <div
            layout="row"
            :layout-align="isCurrent ? 'start center' : 'end center'"
            class="full-width grey--text body-1 pr-2"
          >
            <span>{{$t('_.on')}} {{formatDateHumanI18n(createdAt)}} {{$t('_.at')}} {{formatHour(createdAt)}}</span>
          </div>
        </div>
        <span flex></span>
        <v-menu
          v-if="menuList && menuList.length"
          v-model="menu"
          ref="menu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          origin="top right"
          offset-x
          offset-y
          bottom
          left
          full-width
        >
          <a
            v-if="!$vuetify.breakpoint.smAndDown"
            href="#"
            @click.prevent
            slot="activator"
            class="mr-1"
            :disabled="!menuList || !menuList.length"
          >{{$t('messages.manage')}}</a>
          <v-btn
            v-else
            slot="activator"
            flat
            depressed
            light
            color="transparent"
            :disabled="!menuList || !menuList.length"
            small
            class="ma-0 pa-0 mr-1"
            style="min-width: fit-content;"
          >
            <v-icon color="black">mdi-dots-vertical</v-icon>
          </v-btn>
          <v-list v-if="menuList && menuList.length">
            <v-list-tile
              v-for="(item, index) in menuList"
              :key="index"
              @click="item.action"
              :disabled="item.disabled"
            >
              <v-list-tile-action style="min-width: auto">
                <v-icon
                  :color="item.color ? item.color : 'black'"
                  class="mr-2"
                >mdi-{{item.icon}}</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title
                  v-text="item.title"
                  :class="[item.text ? item.text + '--text' : '']"
                ></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div class="pa2-pc pa1-mobile mt-2">
        <div
          layout="row"
          layout-align="center center"
          class="mb-2"
          style="background-color: #333333"
        >
          <img
            :src="getImageData(message.id)"
            style="max-width: 100%; max-height: 200px; "
          />
        </div>
        <div
          v-if="message.medias && message.medias.length"
          class="grid"
          :id="'grid'+message.id"
          @keydown="onKeyDown"
          tabindex="0"
        >
          <div class="grid-sizer"></div>
          <template v-for="(m,i) in message.medias.slice(0,6)">
            <div
              @click="activeImage(m, i)"
              :key="'media_'+m.id"
              v-if="getImageData(m.id + '-300px') || getImageData(m.id)"
              class="grid-item clickable"
              style="position: relative"
            >
              <video
                v-if="isVideo(getImageData(m.id + '-300px')) || isVideo(getImageData(m.id))"
                :src="getImageData(m.id + '-300px') || getImageData(m.id)"
                allowfullscreen="allow"
                controls
                @click.stop="() => {}"
              ></video>
              <img
                v-else
                :src="getImageData(m.id + '-300px') || getImageData(m.id)"
                style="position: relative"
              />
              <div
                v-if="i == 5 && message.medias.length > 6"
                class="text-image"
              >+{{message.medias.length - 6}}</div>
            </div>
          </template>

          <template v-for="(m,i) in message.medias">
            <div
              v-if="currentImageId == m.id"
              :class="{'gallery-entry': true, 'active': m.id === currentImageId}"
              @click="activeImage(m, i)"
              layout="row"
              layout-align="center center"
              :key="'mediaactive_'+m.id"
            >
              <span
                class="icontainer"
                layout="row"
                layout-align="center center"
              >
                <v-btn
                  icon
                  @click.stop="previousPicture"
                  v-if="m.id === currentImageId"
                  style="position: absolute; z-index: 108; left: 0px;"
                >
                  <v-icon color="white">mdi-arrow-left</v-icon>
                </v-btn>
                <span flex></span>
                <video
                  v-if="isVideo(getImageData(m.id + '-1280px')) || isVideo(getImageData(m.id))"
                  :src="getImageData(m.id + '-1280px') || getImageData(m.id)"
                  allowfullscreen="allow"
                  controls
                  @click.stop="() => {}"
                ></video>
                <img
                  v-else
                  :src="getImageData(m.id + '-1280px') || getImageData(m.id)"
                />
                <span flex></span>
                <v-btn
                  icon
                  @click.stop="nextPicture"
                  v-if="m.id === currentImageId"
                  style="position: absolute; z-index: 108; right: 0px;"
                >
                  <v-icon color="white">mdi-arrow-right</v-icon>
                </v-btn>
              </span>
            </div>
          </template>
        </div>
        <div
          v-if="message.subject"
          class="font-weight-bold subheading mb-2"
        >{{message.subject}}</div>
        <div
          layout="row"
          layout-align="start start"
          class="full-width"
          layout-wrap
        >
          <div
            layout="column"
            class="mb-2"
          >
            <div
              v-linkified
              style="white-space: pre-line; word-wrap: break-word;font-family: inherit;"
            >{{message.body}}</div>
          </div>
          <div
            v-if="isSurvey"
            layout="column"
            layout-align="center center"
            class="participate-col"
          >
            <v-btn
              :disabled="!canParticipate() || !!message.survey_user"
              depressed
              color="secondary"
              @click="$router.push({name: 'messages-survey', params: {id: message.survey_id}})"
              style="text-transform: none"
              large
            >{{$t('messages.participate')}}</v-btn>
            <span v-if="message.survey_user">{{$t('surveys.answered')}} {{formatDateI18n(message.survey_user.created_at)}}</span>
            <span v-else-if="canParticipate()">{{$t('messages.more_than')}} {{timeLeft()}}</span>
            <span v-else>{{$t('surveys.finished')}}</span>
          </div>
          <div
            v-if="isEvent"
            layout="column"
            layout-align="start center"
            class="grey--text text-xs-center"
            :flex="!$vuetify.breakpoint.smAndDown ? 15 : 100"
          >
            <div
              class="display-3 font-weight-bold"
              style="line-height: 1 !important"
            >{{formatDay(message.date_start)}}</div>
            <div class="headline font-weight-bold">{{formatMonthHumanI18n(message.date_start)}}</div>
          </div>
        </div>
        <!-- <div
          layout="row"
          layout-align="start center"
          class="full-width mt-3 body-1 hidden-md-and-up"
        >
          <v-icon class="ml-0 mr-1">mdi-clock</v-icon>
          <span>{{$t('_.on')}} {{formatDateHumanI18n(createdAt)}} {{$t('_.at')}} {{formatHour(createdAt)}}</span>
        </div> -->
        <!-- <div
          v-if="!isMEN && school && school.name"
          layout="row"
          layout-align="start center"
          class="full-width mt-2 hidden-md-and-up"
        >
          <v-icon class="ml-0 mr-1">mdi-domain</v-icon>
          <span>{{school.name}}</span>
        </div> -->
        <div
          v-for="d in message.documents"
          :key="'doc_'+d.id"
          @click="downloadDoc(d)"
          layout="row"
          layout-align="start center"
          class="full-width mt-3 mt2-mobile clickable primary--text"
        >
          <v-icon
            color="primary"
            class="ml-0 mr-1"
          >mdi-paperclip</v-icon>
          <span class="break-word">{{d.document ? d.document.name : ''}}</span>
        </div>
        <div
          v-if="!isReported && targetable && target"
          layout="row"
          layout-wrap
          layout-align="start center"
          class="mt-3 mt2-mobile full-width"
        >
          <div
            layout="row"
            layout-align="start center"
            class="full-width primary--text"
          >
            <v-icon class="mr-1">mdi-target</v-icon>
            <span>{{ isSurvey ? $t('surveys.targeted') : $t('messages.target') }}&nbsp;{{target}}</span>
          </div>
        </div>
        <div
          v-if="isReported && message.reporters && message.reporters.length"
          layout="row"
          layout-wrap
          layout-align="start center"
          class="mt-3 mt2-mobile full-width"
        >
          <div
            layout="row"
            layout-align="start center"
            class="full-width body-1"
            layout-wrap
          >
            <v-icon
              class="mr-1"
              color="red"
            >mdi-alert-octagon</v-icon>
            {{ $t('messages.reported_by') }}&nbsp;
            <div
              v-for="(r,i) in message.reporters"
              :key="r.id + i"
            >
              <span v-if="i == (message.reporters.length - 1) && i != 0">&nbsp;&</span>
              {{r.is_deleted ? $t('users.inactive') : (r.firstname + ' ' + r.lastname)}}
              <span v-if="i < (message.reporters.length - 2)">,&nbsp;</span>
            </div>
          </div>
        </div>
        <div
          v-if="message.refs && message.refs.length"
          layout="row"
          layout-wrap
          layout-align="start center"
          class="mt-2 full-width"
        >
          <div
            layout="row"
            layout-align="start center"
            class="full-width"
          >
            <v-icon class="mr-1">mdi-upload</v-icon>
            {{$t('messages.pushed_by')}}&nbsp;
            <span
              v-for="(r, i) in message.refs"
              :key="'ref_'+i"
            >
              <span v-if="i > 0">&nbsp;>&nbsp;</span>
              <span v-if="r.creator.is_deleted">{{$t('users.inactive')}}</span>
              <span v-else-if="r.creator.id == userId">{{$t('_.yourself')}}</span>
              <a
                v-else
                href="#"
                @click.prevent="$router.push({name: 'representatives-show', params: {id: r.creator.id}})"
              >{{r.creator.firstname}} {{r.creator.lastname.charAt(0)}}.</a>
              ({{levelLabel(r.level)}})
            </span>
          </div>
        </div>
        <div
          v-else-if="message.pushs && message.pushs.length"
          layout="row"
          layout-wrap
          layout-align="start center"
          class="mt-2 full-width"
        >
          <div
            layout="row"
            layout-align="start center"
            class="full-width"
          >
            <v-icon class="mr-1">mdi-upload</v-icon>
            {{$t('messages.pushed_by')}}&nbsp;
            <span
              v-for="(r, i) in message.pushs"
              :key="'ref_'+i"
            >
              <span v-if="i > 0">&nbsp;>&nbsp;</span>
              <span v-if="r.creator.is_deleted">{{$t('users.inactive')}}</span>
              <span v-else-if="r.creator.id == userId">{{$t('_.yourself')}}</span>
              <a
                v-else
                href="#"
                @click.prevent="$router.push({name: 'representatives-show', params: {id: r.creator.id}})"
              >{{r.creator.firstname}} {{r.creator.lastname.charAt(0)}}.</a>
              ({{levelLabel(r.level)}})
            </span>
          </div>
        </div>
        <v-scroll-y-transition>
          <div
            v-if="isEditingMessage"
            layout="column"
            layout-align="start start"
            class="full-width px2-pc pb2-pc pa1-mobile bg-white"
          >
            <message-form
              @cancel="onMessageCancel"
              @save="save"
              ref="messageForm"
              v-model="editingMessage"
              :loading="loading"
            ></message-form>
          </div>
        </v-scroll-y-transition>
        <template v-if="message.answers && message.answers.length">
          <div
            layout="column"
            layout-align="center center"
            class="full-width"
          >
            <hr style="border: none; color: grey; background-color: grey; height: 1px; width: 100%;" />
            <div
              class="mt-2"
              style="text-align: left; width: 100%;"
            >
              <span style="color: #589C8F">
                <strong>{{message.answers.length}}</strong>
              </span>
              <span v-if="message.answers.length === 1">{{$t('messages.answer_has_s')}}</span>
              <span v-else>{{$t('messages.answer_has_p')}}</span>
            </div>
            <div
              layout="column"
              layout-align="center center"
              class="full-width"
            >
              <answer
                v-for="a in message.answers.slice(0, 5)"
                :key="a.id"
                :message="a"
                @edit="onAnswerEdit(a)"
                style="width: 90%"
                class="mt-2"
              />
            </div>
            <v-scroll-x-transition>
              <div
                layout="column"
                layout-align="center center"
                class="full-width"
                v-if="!showLess"
              >
                <answer
                  v-for="a in message.answers.slice(5)"
                  :key="a.id"
                  :message="a"
                  @edit="onAnswerEdit(a)"
                  style="width: 90%"
                  class="mt-2"
                />
              </div>
            </v-scroll-x-transition>
            <a
              href="#"
              @click.prevent="showLess = false"
              v-if="showLess"
            >{{$t('messages.more_answers')}}</a>
            <a
              href="#"
              @click.prevent="showLess = true"
              v-else
            >{{$t('messages.less_answers')}}</a>
          </div>
        </template>
      </div>
    </div>

    <v-dialog
      v-model="pushDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="subheading">{{isNationalTargeted ? $t('messages.push_conf_min') : $t('messages.push_conf_nat')}}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="pushDialog = false"
          >{{$t('_.cancel')}}</v-btn>
          <v-btn
            color="secondary"
            depressed
            @click="pushDialog = false; push()"
          >{{$t('_.send')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('messages.delete_dialog')}}</v-card-title>
        <v-card-text>{{$t('messages.delete_info')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="deleteDialog = false"
          >{{$t('_.cancel')}}</v-btn>
          <v-btn
            color="error"
            depressed
            @click="deleteDialog = false; deleteMessage()"
          >{{$t('_.delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="title">{{$t('messages.remove_dialog')}}</v-card-title>
        <v-card-text>{{$t('messages.remove_info')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="removeDialog = false"
          >{{$t('_.cancel')}}</v-btn>
          <v-btn
            color="error"
            depressed
            @click="removeDialog = false; removeMessage()"
          >{{$t('messages.remove')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import I18nMixin from "@/mixins/i18n"
import Consts from "@/consts"
import ImageMixin from "@/mixins/image"
import Avatar from "@/components/shared/Avatar.vue"
import Auth from "@/plugins/auth"
import Messages from "@/api/messages"
import axios from "axios"
import moment from "moment"
import EventBus from "@/plugins/eventbus"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"
import FormDataMixin from "@/mixins/formdata"
import MessageForm from "@/components/shared/MessageForm.vue"
import Answer from "@/components/shared/Answer.vue"

export default {
  mixins: [I18nMixin, ImageMixin, FormDataMixin],
  components: { Avatar, MessageForm, Answer },

  props: {
    message: {
      type: Object,
      required: true
    },
    isReported: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      imgs: {},
      imgsLoad: {},
      menu: false,
      deleteDialog: false,
      pushDialog: false,
      removeDialog: false,
      currentImageId: null,
      currentImageIndex: null,
      isEditingMessage: false,
      editingMessage: {},
      loading: false,
      showLess: true
    }
  },
  mounted () {
    if (this.message.origin) {
      if (
        this.message.origin.creator &&
        this.message.origin.creator.avatar_id
      ) {
        this.getImage(
          "/assets/users/" + this.message.origin.creator_id,
          this.message.origin.creator_id
        )
      }
    } else {
      if (this.message.creator && this.message.creator.avatar_id) {
        this.getImage(
          "/assets/users/" + this.message.creator_id,
          this.message.creator_id
        )
      }
    }

    if (this.message.banner_id) {
      this.getImage("/assets/event/" + this.message.id, this.message.id)
    }

    //Charge les preview des médias ou directement les médias
    var grid = document.querySelector("#grid" + this.message.id)

    if (grid) {
      var msnry = new Masonry(grid, {
        itemSelector: ".grid-item",
        columnWidth: ".grid-sizer",
        percentPosition: true,
        horizontalOrder: true
      })

      let loadedP = []
      for (let i = 0; i < this.message.medias.length; i++) {
        let l = this.getImage(
          "/assets/messageMedias300px/" + this.message.medias[i].id,
          this.message.medias[i].id + "-300px"
        )
        loadedP.push(l)

        l.catch(() => {
          let l_fallback = this.getImage(
            "/assets/messageMedias/" + this.message.medias[i].id,
            this.message.medias[i].id
          )
          loadedP.push(l_fallback)
        })
      }

      Promise.all(loadedP).then(() => {
        this.$nextTick(() => {
          imagesLoaded(grid, () => {
            msnry.reloadItems()
            msnry.layout()
          })
        })
      })
    }
  },
  computed: {
    byWhoMain () {
      let r = ""
      if (this.isCurrent) {
        r += this.$t("_.yourself")
      } else if (this.isMEN) {
        r += this.$t("_.the") + " MEN"
      } else if (this.isDeleted && !this.isAbusiveManage) {
        r += this.$t("users.inactive")
      } else {
        r += this.fullname
      }
      return r
    },
    byWhoSec () {
      let r = ""
      if (!this.isMEN && this.school && this.school.name) {
        r += "("
        r += this.school.name
        r += ")"
      } else if (this.isMEN && this.isAdmin && !this.isCurrent) {
        r += "("
        r += this.fullname
        r += ")"
      }
      return r
    },
    byWhoReply () {
      let r = ""
      if (this.isCurrent) {
        r += this.$t("_.yourself")
      } else if (this.isMEN) {
        r += this.$t("_.from_1") + " " + " MEN"
      } else if (this.isDeleted && !this.isAbusiveManage) {
        r += this.$t("users.inactive")
      } else {
        r += this.$t("_.from_2") + " " + this.fullname
      }
      return r
    },
    isAnswer () {
      return !!this.message.initial_id
    },
    //Retourne soit le nom complet soit null si l'utilisateur a été anonymisé
    fullname () {
      if (this.message.origin) {
        if (this.isAbusiveManage && this.message.origin.creator.is_deleted) {
          return this.message.origin.created_by
        } else if (
          this.message.origin.created_by &&
          this.message.origin.creator &&
          this.message.origin.creator.firstname &&
          this.message.origin.creator.lastname
        ) {
          return (
            this.message.origin.creator.firstname +
            " " +
            this.message.origin.creator.lastname
          )
        }
        return null
      } else {
        if (this.isAbusiveManage && this.message.creator.is_deleted) {
          return this.message.created_by
        } else if (
          this.message.created_by &&
          this.message.creator &&
          this.message.creator.firstname &&
          this.message.creator.lastname
        ) {
          return (
            this.message.creator.firstname + " " + this.message.creator.lastname
          )
        }
        return null
      }
    },
    userId () {
      return Auth.user.id
    },
    creatorId () {
      if (this.message.origin) {
        return this.message.origin.creator_id
      } else {
        return this.message.creator_id
      }
    },
    createdAt () {
      if (this.message.origin) {
        return this.message.origin.created_at
      } else {
        return this.message.created_at
      }
    },
    school () {
      if (this.message.origin) {
        return this.message.origin.school
      } else {
        return this.message.school
      }
    },
    level () {
      if (this.message.origin) {
        return this.message.origin.level
      } else {
        return this.message.level
      }
    },
    isDeleted () {
      if (this.message.origin) {
        if (this.message.origin.creator.is_deleted) {
          return true
        }
        return false
      } else {
        if (this.message.creator.is_deleted) {
          return true
        }
        return false
      }
    },
    isMEN () {
      if (this.message.origin) {
        if (this.message.origin.level == Consts.MINISTRY) {
          return true
        }
        return false
      } else {
        if (this.message.level == Consts.MINISTRY) {
          return true
        }
        return false
      }
    },
    ministry () {
      return Consts.MINISTRY
    },
    isCurrent () {
      if (this.message.origin) {
        if (Auth.user.id == this.message.origin.creator_id) {
          return true
        }
        return false
      } else {
        if (Auth.user.id == this.message.creator_id) {
          return true
        }
        return false
      }
    },
    target () {
      let str = ""
      if (this.message.levels && this.message.levels.length) {
        if (this.message.levels.length == 1) {
          str += this.$t("filters.the_lv") + " "
        } else {
          str += this.$t("filters.the_lvs") + " "
        }
        for (let i = 0; i < this.message.levels.length; i++) {
          if (i != 0 && i == this.message.levels.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.levels.length > 1) {
            str += ", "
          }
          str += this.levelLabel(this.message.levels[i].level)
        }
      }

      if (this.message.sectors && this.message.sectors.length) {
        if (str.length) {
          str += ", "
        }
        if (this.message.sectors.length == 1) {
          str += this.$t("filters.the_sector") + " "
        } else {
          str += this.$t("filters.the_sectors") + " "
        }
        for (let i = 0; i < this.message.sectors.length; i++) {
          if (i != 0 && i == this.message.sectors.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.sectors.length > 1) {
            str += ", "
          }
          str += this.sectorLabel(this.message.sectors[i].sector)
        }
      }
      if (
        this.message.regional_directorates &&
        this.message.regional_directorates.length
      ) {
        if (str.length) {
          str += ", "
        }
        if (this.message.regional_directorates.length == 1) {
          str += this.$t("filters.the_rd") + " "
        } else {
          str += this.$t("filters.the_rds") + " "
        }
        for (let i = 0; i < this.message.regional_directorates.length; i++) {
          if (i != 0 && i == this.message.regional_directorates.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.regional_directorates.length > 1) {
            str += ", "
          }
          str += this.i18n(this.message.regional_directorates[i].label)
        }
      }
      if (this.message.regions && this.message.regions.length) {
        if (str.length) {
          str += ", "
        }
        if (this.message.regions.length == 1) {
          str += this.$t("filters.the_region") + " "
        } else {
          str += this.$t("filters.the_regions") + " "
        }
        for (let i = 0; i < this.message.regions.length; i++) {
          if (i != 0 && i == this.message.regions.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.regions.length > 1) {
            str += ", "
          }
          str += this.i18n(this.message.regions[i].name)
        }
      }
      if (this.message.cities && this.message.cities.length) {
        if (str.length) {
          str += ", "
        }
        if (this.message.cities.length == 1) {
          str += this.$t("filters.the_city") + " "
        } else {
          str += this.$t("filters.the_cities") + " "
        }
        for (let i = 0; i < this.message.cities.length; i++) {
          if (i != 0 && i == this.message.cities.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.cities.length > 1) {
            str += ", "
          }
          str += this.message.cities[i].label
        }
      }
      if (this.message.schools && this.message.schools.length) {
        if (str.length) {
          str += ", "
        }
        if (this.message.schools.length == 1) {
          str += this.$t("filters.the_school") + " "
        } else {
          str += this.$t("filters.the_schools") + " "
        }
        for (let i = 0; i < this.message.schools.length; i++) {
          if (i != 0 && i == this.message.schools.length - 1) {
            str += " " + this.$t("_.and") + " "
          } else if (i != 0 && this.message.schools.length > 1) {
            str += ", "
          }
          str += this.message.schools[i].name
        }
      }
      return str
    },
    targetable () {
      if (
        this.message.type == Consts.TOPDOWN ||
        this.message.type == Consts.BOTTOMUP ||
        this.message.type == Consts.HORIZONTAL ||
        this.message.type == Consts.SURVEY
      ) {
        return true
      }
      return false
    },
    isAbusiveManage () {
      if (this.$route.name == "abusive-messages-index") {
        return true
      }
      return false
    },
    menuList () {
      let list = []
      if (!this.isAbusiveManage && this.isCurrent) {
        list.push({
          title: this.$t("messages.edit"),
          icon: "pencil",
          action: () => this.$emit(`edit`)
        })
        list.push({
          title: this.$t("messages.delete"),
          icon: "delete",
          color: "red",
          text: "red",
          action: () => this.openDeleteDialog()
        })
      } else {
        if (
          !this.isAbusiveManage &&
          this.message.type == Consts.BOTTOMUP &&
          this.message.levels[0].level != Consts.MINISTRY
        ) {
          if (this.message.is_pushed) {
            if (this.message.ref_id) {
              list.push({
                icon: "upload",
                disabled: true,
                title:
                  this.$t("messages.already_pushed") +
                  this.formatDateI18n(this.message.refs[0].created_at) +
                  " " +
                  this.$t("_.at") +
                  " " +
                  this.formatHour(this.message.refs[0].created_at),
                action: () => { },
                color: "grey",
                text: "grey"
              })
            } else {
              list.push({
                icon: "upload",
                disabled: true,
                title:
                  this.$t("messages.already_pushed") +
                  this.formatDateI18n(this.message.pushs[0].created_at) +
                  " " +
                  this.$t("_.at") +
                  " " +
                  this.formatHour(this.message.pushs[0].created_at),
                action: () => { },
                color: "grey",
                text: "grey"
              })
            }
          } else {
            if (Auth.user.level == Consts.MINISTRY) {
              list.push({
                icon: "upload",
                disabled: true,
                title:
                  this.message.levels[0].level == Consts.NATIONAL
                    ? this.$t("messages.trace")
                    : this.$t("messages.trace_nat"),
                action: () => { },
                color: "grey",
                text: "grey"
              })
            } else {
              list.push({
                title:
                  this.message.levels[0].level == Consts.NATIONAL
                    ? this.$t("messages.trace")
                    : this.$t("messages.trace_nat"),
                icon: "upload",
                action: () => this.openPushDialog()
              })
            }
          }
        }
        if (this.isAdmin) {
          if (this.message.is_enabled) {
            list.push({
              title: this.$t("messages.remove_mess"),
              icon: "lock",
              color: "red",
              action: () => this.openRemoveDialog()
            })

            if (this.message.is_reported) {
              list.push({
                title: this.$t("messages.keep"),
                icon: "shield-check",
                color: "green",
                action: () => this.keep()
              })
            }
          } else {
            list.push({
              title: this.$t("messages.reactivate"),
              icon: "lock-open",
              color: "green",
              action: () => this.reactivate()
            })
          }
        }
      }
      return list
    },
    isAdmin () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
    isSurvey () {
      if (this.message.type == Consts.SURVEY) {
        return true
      }
      return false
    },
    isEvent () {
      if (this.message.type == Consts.EVENT) {
        return true
      }
      return false
    },
    isNationalTargeted () {
      if (
        this.message.levels &&
        this.message.levels.length &&
        this.message.levels[0].level == Consts.NATIONAL
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    onAnswerEdit (a) {
      this.isEditingMessage = true
      this.editingMessage = Object.assign({}, JSON.parse(JSON.stringify(a)))
    },
    newAnswer (who) {
      this.isEditingMessage = true
      this.defaultMessage(who)
      this.$nextTick(() => {
        this.$refs.messageForm.$refs.body_ref.focus()
      })
    },
    defaultMessage (who = "") {
      this.editingMessage = Object.assign(
        {},
        {
          type: Consts.REPLY,
          body: "",
          from: who
        }
      )
    },
    resetMessage () {
      this.$refs.messageForm.$refs.form.reset()
      this.defaultMessage()
    },
    save (data) {
      if (!this.$refs.messageForm.$refs.form.validate()) {
        return
      }

      this.loading = true
      this.editingMessage.initial_id = this.message.id

      // Convert the data to FormData for proper file upload
      let formData = new FormData()
      let o = Object.assign(
        {},
        this.editingMessage,
        { deleted_medias: data.deletedMedias },
        { deleted_docs: data.deletedDocs }
      )
      this._convertObjectToFormData(formData, o)

      for (let i = 0; i < data.medias.length; i++) {
        if (!data.medias[i].id) {
          formData.append(
            "medias[" + i + "]",
            data.medias[i],
            data.medias[i].name
          )
        }
      }

      for (let i = 0; i < data.documents.length; i++) {
        if (!data.documents[i].id) {
          formData.append(
            "documents[" + i + "]",
            data.documents[i],
            data.documents[i].name
          )
        }
      }

      if (!this.editingMessage.id) {
        Messages.create(formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.$snotify.success(this.$t("messages.created"))
            this.$emit("updated")
          },
          () => {
            this.loading = false
          }
        )
      } else {
        Messages.updateAsForm(this.editingMessage.id, formData).then(
          () => {
            this.resetMessage()
            this.loading = false
            this.isEditingMessage = false
            this.$snotify.success(this.$t("messages.edited"))
            this.$emit("updated")
          },
          () => {
            this.loading = false
          }
        )
      }
    },
    onMessageCancel () {
      this.isEditingMessage = false
      this.resetMessage()
    },
    openDeleteDialog () {
      this.deleteDialog = true
    },
    openPushDialog () {
      this.pushDialog = true
    },
    openRemoveDialog () {
      this.removeDialog = true
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t("users.lv_min")
        case Consts.NATIONAL:
          return this.$t("users.lv_nat")
        case Consts.SECTORAL:
          return this.$t("users.lv_sec")
        case Consts.LOCAL:
          return this.$t("users.lv_loc")
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return "primary"
        case Consts.NATIONAL:
          return "pink"
        case Consts.SECTORAL:
          return "secondary"
        case Consts.LOCAL:
          return "brown"
      }
    },
    sectorLabel (s) {
      switch (s) {
        case Consts.PRIMARY:
          return this.$t("schools.sector_prim")
        case Consts.SECONDARY:
          return this.$t("schools.sector_sec")
        case Consts.COMPETENCECENTRE:
          return this.$t("schools.sector_comp")
      }
    },
    typeIcon (t) {
      switch (t) {
        case Consts.EVENT:
          return "calendar"
        case Consts.SURVEY:
          return "clipboard-text"
        case Consts.CIRCLE:
          return "set-none"
        case Consts.PLATFORM:
          return "send"
        case Consts.TOPDOWN:
          return "arrow-expand-down"
        case Consts.BOTTOMUP:
          return "arrow-expand-up"
        case Consts.HORIZONTAL:
          return "arrow-expand-horizontal"
        case Consts.REPLY:
          return "reply"
      }
    },
    push () {
      Messages.push(this.message.id).then(() => {
        this.$snotify.success(this.$t("messages.pushed"))
        if (this.message.ref_id) {
          this.message.refs.push({
            created_at: moment().format("YYYY-MM-DD hh:mm:ss"),
            creator: Auth.user,
            level: Auth.user.level
          })
        } else {
          this.message.pushs.push({
            created_at: moment().format("YYYY-MM-DD hh:mm:ss"),
            creator: Auth.user,
            level: Auth.user.level
          })
        }
        this.message.is_pushed = 1
      })
    },
    keep () {
      Messages.keep(this.message.id).then(() => {
        this.$snotify.success(this.$t("messages.kept"))
        this.$emit(`deleted`)
        EventBus.$emit("abusive-updated")
      })
    },
    reactivate () {
      Messages.enable(this.message.id).then(() => {
        this.$snotify.success(this.$t("messages.reactivated"))
        this.$emit(`deleted`)
      })
    },
    deleteMessage () {
      Messages.delete(this.message.id).then(() => {
        this.$snotify.success(this.$t("messages.deleted"))
        this.$emit(`deleted`)
      })
    },
    removeMessage () {
      Messages.disable(this.message.id).then(() => {
        this.$snotify.success(this.$t("messages.removed"))
        this.$emit(`removed`)
        EventBus.$emit("abusive-updated")
      })
    },
    isVideo (data) {
      if (data && data.indexOf("data:video/") == 0) {
        return true
      }
      return false
    },
    downloadDoc (doc) {
      const doc_id = doc.id
      axios
        .get(`/assets/messageDocs/${doc_id}`, { responseType: "blob" })
        .then(res => {
          this.downloadFile(res.data, doc.document.name)
        })
    },
    canParticipate () {
      if (
        this.message.is_enabled &&
        moment().isSameOrAfter(this.message.date_start) &&
        moment().isSameOrBefore(this.message.date_end)
      ) {
        return true
      }
      return false
    },
    timeLeft () {
      return moment(this.message.date_end).toNow(true)
    },
    onKeyDown (e) {
      if (e.keyCode === 27 /*esc*/) {
        this.activeImage(null, null)
      } else if (
        this.currentImageIndex != null &&
        e.keyCode === 37 /*left arrow*/
      ) {
        this.previousPicture()
      } else if (
        this.currentImageIndex != null &&
        e.keyCode === 39 /*right arrow*/
      ) {
        this.nextPicture()
      }
    },

    previousPicture () {
      if (this.currentImageIndex === 0) {
        this.activeImage(
          this.message.medias[this.message.medias.length - 1],
          this.message.medias.length - 1
        )
      } else {
        this.activeImage(
          this.message.medias[this.currentImageIndex - 1],
          this.currentImageIndex - 1
        )
      }
    },

    nextPicture () {
      if (this.currentImageIndex >= this.message.medias.length - 1) {
        this.activeImage(this.message.medias[0], 0)
      } else {
        this.activeImage(
          this.message.medias[this.currentImageIndex + 1],
          this.currentImageIndex + 1
        )
      }
    },

    activeImage (p, i) {
      this.currentImageIndex = i
      if (
        this.currentImageId === null ||
        (p !== null && p.id !== this.currentImageId)
      ) {
        this.getImage(
          "/assets/messageMedias1280px/" + p.id,
          p.id + "-1280px"
        ).then(
          () => { },
          () => {
            this.getImage("/assets/messageMedias/" + p.id, p.id)
          }
        )

        this.currentImageId = p.id
      } else {
        this.currentImageId = null
      }
    }
  }
};
</script>
<style scoped>
.message-btn {
  height: 14px;
  width: 14px;
  border: 1px;
  border-radius: 50% 50%;
}

/* clear fix */
.grid:after {
  content: "";
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */

.grid-sizer,
.grid-item {
  width: 33.333%;
}

.grid-item {
  float: left;
}

.grid-item img,
.grid-item video {
  display: block;
  max-width: 100%;
  width: 100%;
}

.grid-item {
  position: relative;
}

.grid {
  width: 100%;
  margin: 0 auto;
  outline: none;
  max-width: 500px;
}

.text-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 50px;
}

@media screen and (max-width: 960px) {
  .message-media {
    max-width: 100%;
    max-height: 250px;
  }
  .participate-col {
    width: 100%;
  }
}
@media screen and (min-width: 960px) {
  .message-media {
    max-width: 300px;
    max-height: 300px;
  }
  .participate-col {
    min-width: 250px;
  }
}

.gallery-entry {
  position: relative;
  cursor: pointer;
  margin: 12px;
  /*transition: background-color .3s ease-in-out;*/
}

.gallery-entry.active {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  margin: 0;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.gallery-entry > .icontainer {
  text-align: center;
}

.gallery-entry.active > .icontainer {
  width: 100%;
  height: 100%;
  /*padding-top: 128px;*/
}

.gallery-entry img {
  max-width: 165px;
  max-height: 165px;
}

.gallery-entry.active img,
.gallery-entry.active video {
  max-width: 100%;
  max-height: 100%;
  z-index: 8;
  margin: auto;
}

.gallery-entry > div {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}

.gallery-entry > div > div {
  pointer-events: none;
}

.gallery-entry:hover > div {
  opacity: 1;
}

.gallery-entry.active > div {
  opacity: 1;
  top: 0;
  bottom: unset;
}
</style>
<style>
video.message-media:-webkit-full-screen,
audio.message-media:-webkit-full-screen {
  max-width: 100%;
  max-height: 100%;
}
.linkified {
  word-break: break-all;
}
</style>
